var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagesCrud',{attrs:{"config":_vm.config,"selectedLang":_vm.selectedLang},on:{"config":conf => _vm.$emit('config', conf),"on-save":func => _vm.$emit('on-save', func),"remove-on-save":func => _vm.$emit('remove-on-save', func)}})
}
var staticRenderFns = []

export { render, staticRenderFns }